import React, { useEffect, useState } from "react";
import AdminLayout from "../../layout/AdminLayout";
import { Link } from "react-router-dom";
import { FaCar, FaBuilding, FaUser, FaBullhorn } from "react-icons/fa";
import { MdOutlineScreenShare } from "react-icons/md";
import { getDashboardData } from "../../../api/api";
import { IoFastFoodOutline } from "react-icons/io5";
import { MoonLoader } from "react-spinners"; // Import the loader

const initialDashboardStats = [
  {
    title: "Number of Mobile Locations in system",
    value: 0,
    borderColor: "border-red-600",
    icon: <FaCar className="text-red-600 text-5xl" />,
    link: "/mobileLocations",
  },
  {
    title: "Number of Screens in system",
    value: 0,
    borderColor: "border-green-600",
    icon: <MdOutlineScreenShare className="text-green-600 text-5xl" />,
    link: "/screens",
  },
  {
    title: "Number of Companies Registered",
    value: 0,
    borderColor: "border-blue-600",
    icon: <FaBuilding className="text-blue-600 text-5xl" />,
    link: "/companies",
  },
  {
    title: "Number of Owners Registered",
    value: 0,
    borderColor: "border-yellow-500",
    icon: <FaUser className="text-yellow-500 text-5xl" />,
    link: "/owners",
  },
  {
    title: "Number of Ongoing Campaigns",
    value: 0,
    borderColor: "border-purple-600",
    icon: <FaBullhorn className="text-purple-600 text-5xl" />,
    link: "/campaigns",
  },
  {
    title: "Total campaigns in the system",
    value: 0,
    borderColor: "border-pink-600",
    icon: <FaBullhorn className="text-pink-600 text-5xl" />,
    link: "/campaigns",
  },
  {
    title: "Total Infotainment  Videos in the system",
    value: 0,
    borderColor: "border-black",
    icon: <FaBullhorn className="text-black text-5xl" />,
    link: "/infotainmentvideos",
  },
  {
    title: "Total Fixed Locations ",
    value: 0,
    borderColor: "border-orange-700",
    icon: <IoFastFoodOutline className="text-orange-700 text-5xl" />,
    link: "/fixedLocations",
  },
];

function Dashboard() {
  const [dashboardStats, setDashboardStats] = useState(initialDashboardStats);
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    getDashboardData()
      .then((res) => {
        const data = res?.data?.data;

        if (data) {
          const updatedStats = initialDashboardStats.map((stat, index) => {
            switch (index) {
              case 0:
                return { ...stat, value: data.numberOfVehicles || stat.value };
              case 1:
                return { ...stat, value: data.numberOfScreens || stat.value };
              case 2:
                return { ...stat, value: data.numberOfCompanies || stat.value };
              case 3:
                return { ...stat, value: data.numberOfOwners || stat.value };
              case 4:
                return {
                  ...stat,
                  value: data.numberOfOngoingCampaigns || stat.value,
                };
              case 5:
                return { ...stat, value: data.numberOfCampaigns || stat.value };
              case 6:
                return {
                  ...stat,
                  value: data.numberOfEntertainmentVideos || stat.value,
                };
              case 7:
                return {
                  ...stat,
                  value: data.numberOfRestaurants || stat.value,
                };
              default:
                return stat;
            }
          });

          setDashboardStats(updatedStats);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading when the data is fetched
      });
  }, []);

  return (
    <>
      <AdminLayout>
        <div className="p-10">
          <h1 className="pb-5 text-xl font-bold text-gray-700">Dashboard</h1>
          {loading ? (
            <div className="flex justify-center items-center h-96">
              <MoonLoader color="black" size={50} />
            </div>
          ) : (
            <div className="grid gap-x-5 gap-y-5 grid-cols-12">
              {dashboardStats.map((stats, index) => (
                <Link
                  to={stats.link}
                  key={index}
                  className={`shadow-md rounded-md bg-white border-l-[12px] ${stats.borderColor} px-10 py-8 lg:col-span-4 md:col-span-12 col-span-12`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h1 className="text-gray-400 font-medium text-lg mb-1">
                        {stats.title}
                      </h1>
                      <h1 className="text-gray-700 font-bold text-2xl">
                        {stats.value}
                      </h1>
                    </div>
                    <span>{stats.icon}</span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </AdminLayout>
    </>
  );
}

export default Dashboard;
